// TODO:: This is a temporary solution. Should be removed in the future.
import Konva from 'konva';
import { Stage, CanvasLayer as Layer, Group } from '@picsart/web-layering/types';
import { getNodeLayer } from '@picsart/web-layering/rendering/konva/selectors';
import { Node } from 'konva/lib/Node';

export const batchDrawNode = (node: Stage | Layer | Group| Node) => (
  node instanceof Konva.Stage || node instanceof Konva.Layer
    ? node.batchDraw()
    : getNodeLayer(node as any)?.batchDraw());
